module.exports = __webpack_public_path__ + "6942cc21375b3a4557e1a22c27c88206.pdf";